import { useState, useEffect } from 'react';
import { loadFilterSelectorList } from '@/pages/dashboard/services/dashboard';


let filterVisibleListCache: any = {}

const useVisible = (props) => {
  const {
    gameCode
  } = props
  const [loading, setLoading] = useState(true)
  const [filterVisibleList, setFilterVisibleList] = useState(filterVisibleListCache?.[gameCode])

  useEffect(() => {
    if (filterVisibleList) {
      setLoading(false)
      return
    }
    loadFilterSelectorList({ game_code: gameCode })
      .then((result) => {
        setFilterVisibleList(result)
        filterVisibleListCache[gameCode] = result
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setLoading(false)
      })
      return () => {
        setFilterVisibleList(null)
      }
  }, [gameCode])

  return {
    visibleLoading: loading,
    filterVisibleList
  }
}

export default useVisible